import { DefaultLegacyGetOptions, SortDirection } from '@bymason/api-base';
import { Subset } from '@bymason/utils';

export const SimStates = [
  'active',
  'canceled',
  'deactivated',
  'inactive',
  'new',
  'ready',
  'scheduled',
  'suspended',
  'updating',
] as const;

export type SimState = typeof SimStates[number];

export type SimType = 'twilio' | 'twilio_super' | 'mock';

export type UpdateSimStatusSubet = Subset<SimState, 'active' | 'inactive' | 'suspended'>;

export interface GenerateUageReportOptions {
  email: string;
  endDate: Date;
  startDate: Date;
}

export interface GetByDayOptions {
  date: Date;
  iccid?: string;
}

export interface GetBySimsOptions extends DefaultLegacyGetOptions {
  month: Date;
  orderBy?: SortDirection;
  orderByColumn?: string;
  status?: SimState;
}

export interface GetSimConnectivityOptions {
  iccidList: string[];
}

export interface UpdateSimStatusOptions {
  requests: UpdateSimStatusOptionRequest[];
}
export interface UpdateSimStatusOptionRequest {
  iccid: string;
  state: UpdateSimStatusSubet;
}

export interface UpdateSimStatusResponse {
  id: string;
  status: string;
}

export interface SimModelDevice {
  imei: string;
  uuid: string;
  serial: string;
  name: string;
}

export interface SimModelUsage {
  iccid: string;
  upload: number;
  download: number;
  total: number;
  unit: string;
}

export interface SimModel {
  iccid: string;
  simType: SimType;
  status: SimState;
  device: SimModelDevice;
  usage?: SimModelUsage;
}

export interface UsageModel {
  upload: number;
  download: number;
  total: number;
  units: string;
  day: string;
}
